import './MarkdownView.css';

import ReactMarkdown, { Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import clsx from 'clsx';
import { toMarkdownString } from './utils/toMarkdownString';

interface MarkdownViewProps {
  value: unknown;
  maxHeight?: string;
  minHeight?: string;
  className?: string;
  components?: Components;
}

const MarkdownView = ({
  value,
  maxHeight,
  minHeight,
  className,
  components,
}: MarkdownViewProps) => {
  const content = toMarkdownString(value);

  const customStyle = {
    ...(maxHeight ? { maxHeight } : {}),
    ...(minHeight ? { minHeight } : {}),
  };

  return (
    <div className={clsx('markdown-view', className)} style={customStyle}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>{content}</ReactMarkdown>
    </div>
  );
};

export default MarkdownView;
